export enum menuSteps {
  preliminary = "Preliminary Questions",
  selfAssessment = "Startup Leadership Index Self-Assessment",
  behaviors = "Leadership Behaviors",
  final = "Final Questions",
}
